var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { connect } from 'react-redux';
import * as OrderFactory from '../../classes/definitions/order/order';
import ApiRequests from '../../classes/http/ApiRequests';
import HttpRequests from '../../classes/http/HttpRequests';
import OrdersList from '../../components/Orders/OrdersList/OrdersList';
import OrdersReduxProps from './OrdersReduxProps';
var Orders = /** @class */ (function (_super) {
    __extends(Orders, _super);
    function Orders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.queryParams = { page: 1, filter: '' };
        _this.state = {
            data: [],
            meta: null,
            delaySearchTimer: null,
        };
        _this.getAllOrders = function () {
            if (_this.queryParams.filter) {
                _this.searchOrders();
            }
            else {
                _this.api
                    .getOrders(_this.queryParams)
                    .then(function (response) { return _this.handleSuccessFromOrders(response); })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с потребители', _this.props.history);
                });
            }
        };
        _this.searchOrders = function () {
            _this.api
                .searchOrders(_this.queryParams)
                .then(function (response) { return _this.handleSuccessFromOrders(response); })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с поръчки', _this.props.history);
            });
        };
        _this.search = function (event) {
            clearTimeout(_this.state.delaySearchTimer);
            var searchVal = event.target.value;
            _this.queryParams.filter = event.target.value;
            _this.queryParams.page = 1;
            if (searchVal) {
                _this.setState({
                    delaySearchTimer: setTimeout(function () {
                        _this.searchOrders();
                    }, 1000),
                });
                return;
            }
            _this.getAllOrders();
        };
        _this.changePage = function (pageNum) {
            _this.queryParams.page = pageNum;
            _this.getAllOrders();
        };
        _this.handleSuccessFromOrders = function (response) {
            var orders = OrderFactory.createOrders(response.data);
            var meta = _.get(response, 'data.meta', null);
            _this.setState({ data: orders, meta: meta });
        };
        return _this;
    }
    Orders.prototype.componentDidMount = function () {
        this.getAllOrders();
    };
    Orders.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041F\u043E\u0440\u044A\u0447\u043A\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Messages, { ref: function (el) {
                                _this.messages = el;
                            } }),
                        React.createElement(OrdersList, { gridData: data, messages: this.messages, meta: meta, changePage: this.changePage, search: this.search }))))));
    };
    return Orders;
}(React.Component));
export default connect(null, OrdersReduxProps.mapDispatchToProps)(Orders);



//////////////////
// WEBPACK FOOTER
// ./src/views/Orders/Orders.tsx
// module id = 394
// module chunks = 0